import React from 'react';
import { Users } from 'lucide-react';
import EmployeeList from "../../components/EmployeeList";

export default function Employees() {
    return (
        <div className="w-full pb-10">
            {/* Header */}
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
                    <span className="p-2 bg-emerald-100 rounded-xl text-emerald-600">
                        <Users size={32} />
                    </span>
                    Employee Management
                </h1>
                <p className="text-gray-500 text-sm mt-2 ml-1">
                    Manage your staff, track attendance, and handle payroll details efficiently.
                </p>
            </div>

            <EmployeeList />
        </div>
    );
}